import React, { useEffect, useState, useContext } from "react";
//import { AiFillFacebook } from "react-icons";
import {
    FaFacebookSquare,
    FaTwitter,
    FaYoutube,
    FaInstagram,
    FaLinkedinIn,
} from "react-icons/fa";
import URLstateContext from "../../provider/CommonContext";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import logoImg from "./../../Images/logo.png";
import AppStore from "./../../Images/appstore.png";
import PlayStore from "./../../Images/playstore.png";
import pdfFirst from "./../../pdf/CLIENT-BANK-ACCOUNT-DETAILS.PDF";
import TabFooter from "./TabFooter";
import pdfClient from "./../../pdf/Advisory for Investors.pdf";
import { Apiurl } from "../Configuration/configuration";

const data = [
    {
        header: "Products",
        submenu: [
            {
                url: "/market/stocks",
                title: "Equity",
            },
            {
                url: "/market/ipo",
                title: "IPO",
            },
            {
                url: "/market/mutual-funds",
                title: "Mutual Fund",
            },
            {
                url: "/market/futures-and-options",
                title: "F & O",
            },
            {
                url: "/market/currency",
                title: "Currency",
            },
            {
                url: "/market/commodity",
                title: "Commodity",
            },
            {
                url: "/market/etf",
                title: "ETF",
            },
            {
                url: "/market/sgb",
                title: "SGB",
            },

        ],
    },

    // {
    //   header: "MARKET INFO",
    //   submenu: [
    //     {
    //       url: "https://www.google.com/",
    //       title: "Equity",
    //     },
    //     {
    //       link: "/DerivativeTrading",
    //       title: "Derivative",
    //     },

    //     {
    //       link: "/CommodityTrading",
    //       title: "IPO",
    //     },

    //     {
    //       link: "/CurrencyTrading",
    //       title: "Mutual Fund",
    //     },

    //     {
    //       link: "/Depository",
    //       title: "Currency",
    //     },
    //   ],
    // },

    {
        header: "Why Trade with Us",
        submenu: [
            {
                url: "/AlgoTrading",
                title: "Backtest your Algo Strategies",
            },
            {
                url: "/About",
                title: "Decades of Experience",
            },

            // {
            //     url: "/ReferEarn",
            //     title: "Referral program",
            // },

            {
                url: "/PartnerUs",
                title: "Partner with us",
            },
            {
                url: "/AlgoTrading",
                title: "Algo Trading",
            },
            {
                url: "/FoxTrader",
                title: "Real time Charts",
            },
            {
                url: "/userReferal",
                title: "Refer & Earn",
            },
        ],
    },

    {
        header: "RESEARCH",
        submenu: [
            // {
            //     url: "/Research/morning-note",
            //     title: "Market Hunt",

            // },
            {
                url: "/Research/market-hunt",
                title: "Market Hunt",

            },
            {
                url: "/Research/derivative-reports",
                title: "Derivative reports",

            },

            {
                url: "/Research/metal-energy-watch",
                title: "Commodity reports",

            },

            // {
            //     url: "/Research/company-reports",
            //     title: "Company reports",

            // },

            {
                url: "/Research/margin-report",
                title: "Margin updates",

            },

            {
                url: "/Research/monthly-magazine",
                title: "Monthly Magazine",

            },
            {
                url: "https://learn.moneysukh.com/category/blogs/",
                title: "Blogs",
            }
        ],
    },

    {
        header: "useful links",
        submenu: [
            // {
            //   url: "https://www.google.com/",
            //   title: " WealthTracker ",
            // },
            {
                url: "/Downloads",
                title: "Downloads",

            },

            {
                url: "/Investor-Relations",
                title: "Investor Relations",
            },
            // {
            //     url: "http://kyctracker.moneysukh.com/",
            //     title: "KYC Tracker",
            //     target: "_blank",
            // },
            {
                url: "https://moneysukh-web.mithiskyconnect.com/",
                title: "Email : moneysukh.com",
                target: "_blank",
            },
            {
                url: "https://webmail.rediffmailpro.com/action/login/mansukh.in",
                title: "Email : mansukh.in",
                target: "_blank",
            },
            {
                url: "/Careers",
                title: "Career",

            },
            {
                url: "/Sitemap",
                title: "Sitemap",

            },
            {
                url: " https://rekyc.moneysukh.com:9443/directpan.aspx",
                title: "Account modification",
                target: "_blank",

            },


            // {
            //     url: "/Contact",
            //     title: "Contact Us",
            // },
            // {
            //   link: "/",
            //   title: "Back Office",
            // },
            // {
            //   link: "/CurrencyTrading",
            //   title: "New Visitor",
            // },
        ],
    },
];

const BSEmeone =
    "Mansukh Securities and Finance Limited : SEBI Registration Number-INZ000164537 ( Members-NSE,BSE,MCX,MSEI ),IN-DP-72-2015 (DP-NSDL)";
const BSEmetwo =
    "Mansukh Stock Brokers Limited : SEBI Registration Number- INZ000164937 ( Members -BSE ), IN-DP-36-2015 (DP-CDSL)";
const BSEmethree =
    "Algocomm Futures Private Limited : SEBI Registration Number-INZ000063032 ( Members- NCDEX ) ";
const BSEmefoure =
    "Mansukh IFSC Broking Private Limited : SEBI Registration Number- INZ000099432 (Members- INDIA INX)";
const AttInve = "Attention Investors:";
const copywrite = "All rights reserved ©2023 Mansukh Securities & Finance Ltd.";
const power = "Powered by CMOTS Infotech (ISO 9001:2015 certified)";
const marqueetext =
    "It has come to our notice that some unauthorized SMSes are being circulated in the name of Mansukh Securities & Finance ltd( Mansukh Group)  inducing clients to invest in scrips, not recommended by us. Mansukh Securities & Finance ltd( Mansukh Group) does not send any unsolicited SMS. Investors are cautioned against such unauthorized SMSes/Emails from unknown sources and requested not to reply on such SMSes or emails. Clients are advised to verify the genuinity of the source before initiating any trades in the said scrips. Mansukh Securities & Finance ltd( Mansukh Group) shall not be liable whatsoever for any losses incurred for trading done based on calls from such unauthorized sources. Pay 20% upfront margin of the transaction value to trade in cash market segment.Investors may please refer to the Exchange's Frequently Asked Questions (FAQs) issued vide circular reference NSE/INSP/45191 dated July 31, 2020 and NSE/INSP/45534 dated August 31, 2020 and other guidelines issued from time to time in this regard.This is to inform you that we do client based trading and Pro-account trading.";
const disclaimer = "Disclaimer";
const bseforms = "BSE Complaints/Arbitration Forms";
const privacypolicy = "Privacy Policy";
const termsconditions = "Terms and Conditions";
const grievances = "grievances@moneysukh.com";

function Footer() {
    const { BaseLiveURL } = useContext(URLstateContext);
    const [dataBank, setDataBank] = useState(false);
    let navigate = useNavigate();
    const changeRouteDisclaimer = () => {
        let path = `Disclaimer`;
        navigate(path);
    };

    const [activeSlide, setActiveSlide] = useState(0);

    const settings = {
        afterChange: (current) => setActiveSlide(current),
    };


    const changeRoutePrivacy = () => {
        let path = `PrivacyPolicy`;
        navigate(path);
    };
    const changeRouteTerm = () => {
        let path = `TermsCondition`;
        navigate(path);
    };
    const changeRouteInvestorCharter = () => {
        let path = `InvestorCharter`;
        navigate(path);
    };
    const changeacc = () => {
        let path = `AccountClosure`;
        navigate(path);
    }
    const changeRisk = () => {
        let path = `RiskDisclosures`;
        navigate(path);
    }

    useEffect(() => {
        postData(`${Apiurl}/api/Login/BankAccountDetails`)
            .then((data) => {
                if (data.data != null && data.data.length > 0) { setDataBank(data.data) }
                else { setDataBank(null) }
            });
    }, []);

    async function postData(url = '', data = {}) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }

    // return (
    //     <>
    //         <Container fluid className="AttentionBG">
    //             <Container>
    //                 <Row>
    //                     <Col
    //                         md={3}
    //                         lg={3}
    //                         xl={2}
    //                         className="Attentionheading AttentionheadignText"
    //                     >
    //                         {AttInve}
    //                     </Col>
    //                     <Col md={8} lg={9} xl={10}>
    //                         {" "}
    //                         <marquee className="Attentionheading">
    //                             {" "}
    //                             {marqueetext}{" "}
    //                         </marquee>{" "}
    //                     </Col>
    //                 </Row>
    //             </Container>
    //         </Container>
    //         <div className="footerbottom_main">

    //             <Container>
    //             <Row>
    //                 <Col>
    //                 <TabFooter />
    //                 <div className="footerbottom_grid  d-felx-Block">

    //                 <div className="FooterAllLink footer-logo-block">
    //                     <img className="img-fluid" src={logoImg} alt="logo-img" />
    //                     <h3>
    //                         96382-38000
    //                         <small>(Support)</small>
    //                     </h3>
    //                     <h3>
    //                         96382-37000 <small>(Sales)</small>
    //                     </h3>
    //                     <h3>
    //                         96382-36000
    //                         <small> (Dealing)</small>
    //                     </h3>

    //                 </div>
    //                 <div>
    //                     <ul className="social-links-list">
    //                         <li>
    //                             <a target="_blank" href="https://www.facebook.com/moneysukh.online/">
    //                                 <FaFacebookSquare />
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a target="_blank" href="https://twitter.com/moneysukhonline">
    //                                 <FaTwitter />
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a target="_blank" href="https://www.youtube.com/@moneysukhofficial">
    //                                 <FaYoutube />
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a target="_blank" href="https://www.instagram.com/moneysukhofficial/">
    //                                 <FaInstagram />
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a target="_blank" href="https://www.linkedin.com/company/mansukh-securities-&-finance-ltd./">
    //                                 <FaLinkedinIn />
    //                             </a>
    //                         </li>
    //                     </ul>
    //                     </div>
    //                 {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
    //                             {data.map((data, i) => {
    //                                 return (
    //                                     <div className="FooterAllLink" key={i}>
    //                                         <ul>
    //                                             <li> {data.header} </li>
    //                                             {data.submenu.map((submenus, m) => {
    //                                                 return (
    //                                                     <>
    //                                                         <li key={1 + 1}>
    //                                                             <a href={submenus.url}
    //                                                                 target={submenus.target}> {submenus.title} </a>
    //                                                         </li>
    //                                                     </>
    //                                                 );
    //                                             })}
    //                                         </ul>
    //                                     </div>
    //                                 );
    //                             })}

    //             </div>
    //                 </Col>
    //             </Row>
    //             </Container>
    //             <Row>
    //                 <Col className="BSEMemberText">
    //                     <ul>
    //                         <li>
    //                             Mansukh Securities and Finance Limited : SEBI Registration
    //                             Number-INZ000164537 ( Members-NSE,BSE,MCX, ),IN-DP-72-2015 (
    //                             DP-NSDL, CDSL ) Mansukh Stock Brokers Limited : SEBI
    //                             Registration Number- INZ000164937 ( Members -BSE ),
    //                             IN-DP-36-2015 Mansukh Commodity Futures Private Limited : SEBI
    //                             Registration Number-INZ000063032 ( Members- NCDEX ) Mansukh IFSC
    //                             Broking Private Limited : SEBI Registration Number- INZ000099432
    //                             (Members- NSE IFSC, INDIA INX)
    //                         </li>
    //                         <li>
    //                             Procedure to file a complaint on SEBI SCORES: Register on SCORES
    //                             portal. Mandatory details for filing complaints on SCORES: Name,
    //                             PAN, Address, Mobile Number, E-mail ID. Benefits: Effective
    //                             Communication, Speedy redressal of the grievances
    //                         </li>
    //                         <li>
    //                             Investments in securities market are subject to market risks;
    //                             read all the related documents carefully before investing.
    //                         </li>
    //                         {/* <li> {BSEmetwo} </li>
    //             <li> {BSEmethree} </li>
    //             <li> {BSEmefoure} </li> */}
    //                     </ul>
    //                 </Col>
    //             </Row>
    //             <Row>
    //                 <Col className="footerDisclaimerLink">
    //                     <ul>
    //                         <li>
    //                             <span onClick={changeRouteDisclaimer}>
    //                                 <a href=""> {disclaimer} </a>
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 <a
    //                                     target="_blank"
    //                                     href="https://www.bseindia.com/static/investors/cac_tm.aspx"
    //                                 >
    //                                     {bseforms}
    //                                 </a>
    //                             </span>
    //                             <small>|</small>
    //                             <span onClick={changeRoutePrivacy}>
    //                                 <a href=""> {privacypolicy} </a>
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 <a
    //                                     target="_blank"
    //                                     href="https://moneysukh-web.mithiskyconnect.com/"
    //                                 >
    //                                     Email
    //                                 </a>
    //                             </span>
    //                             <small>|</small>
    //                             <span onClick={changeRouteTerm}>
    //                                 <a href=""> {termsconditions} </a>
    //                             </span>
    //                             <small>|</small>
    //                             <span onClick={changeRouteInvestorCharter}>
    //                                 <a href=""> Investor Charter and Disclosures</a>
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 <a href="/Contact"> Contact Us</a>
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 Corporate Announcements
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 <a href="http://download.moneysukh.com:6633/">Softwares</a>
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 <a href="http://rms.moneysukh.com/(S(jtfelene1jwfmwrppz24rq3e))/Default.aspx">RMS Login</a>
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 <a href={pdfFirst} target="_blank">Client Bank Account Details</a>
    //                             </span>
    //                             <small>|</small>
    //                             <span>
    //                                 <a href="https://eservices.nsdl.com/" target="_blank">E-VOTING</a>
    //                             </span>
    //                         </li>
    //                         <li>

    //                             Customers can send in their Grievances to : <a href="mailto:grievances@moneysukh.com">{grievances} </a> (Equity &
    //                             Derivative), <a href="mailto:commgrievances@moneysukh.com">commgrievances@moneysukh.com</a> (Commodity),
    //                             <a href="mailto:dpgrievances@moneysukh.com">dpgrievances@moneysukh.com</a> (Depository){" "}
    //                             {/* <span>
    //                   Copyright &copy;2007 Mansukh Securities & Finance Ltd.
    //                 </span> */}
    //                             <small>|</small>
    //                             <span onClick={changeacc}>
    //                                 <a href="">Account Closure</a>
    //                             </span>
    //                             <small>|</small>
    //                             <span onClick={changeRisk}>
    //                                 <a href="">Risk Disclosures</a>
    //                             </span>
    //                         </li>

    //                     </ul>
    //                     <ul className="useful-links-block">
    //                         <li>
    //                             <span>Important links:</span>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.nseindia.com/" target="_blank">
    //                                 NSE
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.bseindia.com/" target="_blank">
    //                                 BSE
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.cdslindia.com/" target="_blank">
    //                                 CDSL
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://nsdl.co.in/" target="_blank">
    //                                 NSDL
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.sebi.gov.in/" target="_blank">
    //                                 SEBI
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.mcxindia.com/" target="_blank">
    //                                 MCX
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.msei.in/" target="_blank">
    //                                 MSEI
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.ncdex.com/" target="_blank">
    //                                 NCDEX
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.nseifsc.com/" target="_blank">
    //                                 NSE IFSC
    //                             </a>
    //                         </li>
    //                         <li>
    //                             <a href="https://www.indiainx.com/" target="_blank">
    //                                 INDIA INX
    //                             </a>
    //                         </li>
    //                     </ul>
    //                     <ul className="prevent-block">
    //                         <li>
    //                             <p className="footerp">
    //                                 <b>Attention Investors:</b> As per NSE circular dated July 6, 2022, BSE circular dated July 6, 2022, MCX circular dated July 11, 2022 investors are cautioned to abstain them from dealing in any schemes of unauthorised collective investments/portfolio management, indicative/ guaranteed/fixed returns / payments etc. Investors are further cautioned to avoid practices like:</p>
    //                             <p className="footerp">
    //                                 a) Sharing i) trading credentials – login id & passwords including OTP’s., ii) trading strategies, iii) position details.</p>
    //                             <p className="footerp">
    //                                 b) Trading in leveraged products /derivatives like Options without proper understanding, which could lead to losses.</p>
    //                             <p className="footerp">
    //                                 c) Writing/ selling options or trading in option strategies based on tips, without basic knowledge & understanding of the product and its risks</p>
    //                             <p className="footerp">
    //                                 d) Dealing in unsolicited tips through like Whatsapp, Telegram, Instagram, YouTube, Facebook, SMS, calls, etc.</p>
    //                             <p >
    //                                 e) Trading / Trading in “Options” based on recommendations from unauthorised / unregistered investment advisors and influencers.</p>
    //                             <p>
    //                                 Kindly, read the Advisory Guidelines For Investors as prescribed by the Exchange with reference to their circular dated 27th August, 2021 regarding investor awareness and safeguarding client's assets
    //                             </p>
    //                             <p>
    //                                 Kindly, read the advisory as prescribed by the Exchange with reference to their circular dated January 14, 2022 regarding Updation of mandatory KYC fields by March 31, 2022
    //                             </p>
    //                             <p>
    //                                 <b>Attention Investors:</b> Prevent unauthorized transactions in your demat account. Update your mobile number with your depository participant. Receive alerts on your registered mobile number for debit and other important transactions in your demat account directly from CDSL on the same day. Prevent unauthorized transactions in your trading account. Update your mobile numbers/email address with your stock brokers. Receive information of your transactions directly from the Exchange on your mobile/email at the end of the day. This is issued in the interest of investors. KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI registered intermediary (broker, DP, Mutual Fund, etc...), you need not undergo the same process again when you approach another intermediary.
    //                             </p>
    //                             <p>
    //                                 No need to issue cheques by investors while subscribing to IPO. Just write the bank account number and sign in the application form to authorise your bank to make payment in case of allotment. No worries for refund as the money remains in investor's account.
    //                             </p>
    //                             <p className="footerp">
    //                                 Stockbrokers can accept securities as margin from their clients only by way of a pledge in the depository system w.e.f. 1st September 2020.</p>
    //                             <p>
    //                                 Update your email ID and mobile number with your stockbroker/depository participant and receive an OTP directly from the depository on your registered email ID and/or mobile number to create a pledge.
    //                                 Check your securities/mutual funds/bonds in the Consolidated Account Statement (CAS) issued by NSDL/CDSL every month.
    //                             </p>

    //                         </li>
    //                     </ul>
    //                 </Col>
    //             </Row>
    //             <section className="copyright-cmots">
    //                 <Row>
    //                     <Col sx={12} lg={6} md={6}>
    //                         <p className="copyright_text m-0">{copywrite}</p>
    //                     </Col>
    //                     <Col sx={12} lg={6} md={6}>
    //                         <div className="footerapp_panel text-right">
    //                             <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN">
    //                                 <img src={PlayStore} alt="PlayStore" />
    //                             </a>
    //                             <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241">
    //                                 <img src={AppStore} alt="AppStore" />
    //                             </a>
    //                         </div>
    //                     </Col>
    //                 </Row>
    //                 <Row>
    //                     <Col sx={12} lg={12} md={12} className="text-right">
    //                         <span className="copyright_text m-0"> Designed,Developed and Content powered by <a target='_blank' href="http://www.cmots.com/">CMOTS Infotech </a> (ISO 9001:2015 certified) </span>
    //                     </Col>
    //                 </Row>
    //             </section>

    //         </div>
    //     </>
    // );
    return (
        <>

            <Container fluid className="AttentionBG">
                <Container>
                    <Row>
                        <Col
                            md={3}
                            lg={3}
                            xl={2}
                            className="Attentionheading AttentionheadignText"
                        >
                            {AttInve}
                        </Col>
                        <Col md={8} lg={9} xl={10}>
                            {" "}
                            {/* old marquee */}
                            {/* <marquee className="Attentionheading">
                                {" "}
                                {marqueetext}{" "}
                            </marquee>{" "} */}


                            {/* new marquee option*/}
                            <div className="newScrollPara">
                                <p className="Attentionheading">
                                    {" "}
                                    {marqueetext}{" "}
                                </p></div>{" "}

                        </Col>
                    </Row>
                </Container>
            </Container>
            <div className="Bgblue">
                <Container>
                    <Row>
                        <Col>
                            <TabFooter />
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="footerbottom_main">
                <Container>
                    <Row>
                        <Col>
                            <div className="footerbottom_grid justify-content-between d-felx-Block">
                                <div className="FooterAllLink footer-logo-block">
                                    <img className="img-fluid" src={logoImg} alt="logo-img" />
                                    <p>
                                        96382-38000
                                        <small>(Support)</small>
                                    </p>
                                    <p>
                                        96382-37000 <small>(Sales)</small>
                                    </p>
                                    <p>
                                        96382-36000
                                        <small> (Dealing)</small>
                                    </p>
                                    <ul className="social-links-list">
                                        {/* <li>
                                            <a target="_blank" href="https://www.facebook.com/moneysukh.online/">
                                                <FaFacebookSquare />
                                            </a>
                                        </li> */}
                                        <li>
                                            <a target="_blank" href="https://www.facebook.com/moneysukh.online/" aria-label="Visit our Facebook page" rel="noopener noreferrer" title="Visit our Facebook page" ><FaFacebookSquare aria-hidden="true" /></a>

                                        </li>

                                        {/* add aria label */}

                                        <li>
                                            <a target="_blank" href="https://twitter.com/moneysukhonline" aria-label="Visit our Twitter Profile">
                                                <FaTwitter />
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.youtube.com/@moneysukhofficial" aria-label="Visit our Youtube Chennal">
                                                <FaYoutube />
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.instagram.com/moneysukhofficial/" aria-label="Visit our Instagram page">
                                                <FaInstagram />
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.linkedin.com/company/mansukh-securities-&-finance-ltd./" aria-label="Visit our Linkedin Profile">
                                                <FaLinkedinIn />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                {data.map((data, i) => {
                                    return (
                                        <div className="FooterAllLink" key={i}>
                                            <ul>
                                                <li> {data.header} </li>
                                                {data.submenu.map((submenus, m) => {
                                                    return (
                                                        <>
                                                            <li key={1 + 1}>
                                                                <a href={submenus.url}
                                                                    target={submenus.target}> {submenus.title} </a>
                                                            </li>
                                                        </>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    );
                                })}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="BSEMemberText">
                            <ul>
                                <li>
                                    Mansukh Securities and Finance Limited : SEBI Registration
                                    Number-INZ000164537 ( Members-NSE,BSE,MCX, ),IN-DP-72-2015 (
                                    DP-NSDL, CDSL ), INH100003274 (Research Analyst), Mansukh Stock Brokers Limited : SEBI
                                    Registration Number- INZ000164937 ( Members -BSE ).
                                    Algocomm Futures Private Limited : SEBI
                                    Registration Number-INZ000063032 ( Members- NCDEX ) Mansukh IFSC
                                    Broking Private Limited : SEBI Registration Number- INZ000099432
                                    (Members- INDIA INX)
                                </li>
                                <li>
                                    Procedure to file a complaint on <a href="https://scores.sebi.gov.in" target="_blank">SEBI SCORES</a>: Register on SCORES
                                    portal. Mandatory details for filing complaints on SCORES: Name,
                                    PAN, Address, Mobile Number, E-mail ID. Benefits: Effective
                                    Communication, Speedy redressal of the grievances
                                </li>
                                <li>
                                    Investments in securities market are subject to market risks;
                                    read all the related documents carefully before investing.
                                </li>
                                {/* <li> {BSEmetwo} </li>
                <li> {BSEmethree} </li>
                <li> {BSEmefoure} </li> */}
                            </ul>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="footerDisclaimerLink">
                            <ul>
                                <li>
                                    <span onClick={changeRouteDisclaimer}>
                                        <a href=""> {disclaimer} </a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a
                                            target="_blank"
                                            href="https://www.bseindia.com/static/investors/cac_tm.aspx"
                                        >
                                            {bseforms}
                                        </a>
                                    </span>
                                    <small>|</small>
                                    <span onClick={changeRoutePrivacy}>
                                        <a href=""> {privacypolicy} </a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a
                                            target="_blank"
                                            href="https://moneysukh-web.mithiskyconnect.com/"
                                        >
                                            Email
                                        </a>
                                    </span>
                                    <small>|</small>
                                    <span onClick={changeRouteTerm}>
                                        <a href=""> {termsconditions} </a>
                                    </span>
                                    <small>|</small>
                                    <span onClick={changeRouteInvestorCharter}>
                                        <a href=""> Investor Charter and Disclosures</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="/Contact"> Contact Us</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        Corporate Announcements
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://download.moneysukh.com:6633/">Softwares</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://rms.moneysukh.com/(S(jtfelene1jwfmwrppz24rq3e))/Default.aspx">RMS Login</a>
                                    </span>
                                    <small>|</small>
                                    {dataBank &&
                                        dataBank.map(
                                            ({ filename }) => (
                                                <span>
                                                    <a href={BaseLiveURL + "pdf/" + filename} target="_blank">Client Bank Account Details</a>
                                                </span>
                                            )
                                        )}
                                    <small>|</small>
                                    <span>
                                        <a href="https://eservices.nsdl.com/" target="_blank">E-VOTING</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://support.moneysukh.com/account-opening-process/" target="_blank">Account Opening Process</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://support.moneysukh.com/raise-a-ticket/" target="_blank">Raise Ticket</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://support.moneysukh.com/key-managerial-personnel/" target="_blank">Key Managerial Personnel</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://support.moneysukh.com/basic-details-of-moneysukh/" target="_blank">Basic Details</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://support.moneysukh.com/escalation-matrix/" target="_blank">Escalation Matrix</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://support.moneysukh.com/authorised-persons/" target="_blank">Authorized Persons</a>
                                    </span>
                                </li>
                                <li>

                                    Customers can send in their Grievances to : <a href="mailto:grievances@moneysukh.com">{grievances} </a> (Equity &
                                    Derivative), <a href="mailto:commgrievances@moneysukh.com">commgrievances@moneysukh.com</a> (Commodity),
                                    <a href="mailto:dpgrievances@moneysukh.com">dpgrievances@moneysukh.com</a> (Depository){" "}
                                    {/* <span>
                      Copyright &copy;2007 Mansukh Securities & Finance Ltd.
                    </span> */}
                                    <small>|</small>
                                    {/* <span onClick={changeacc}> */}
                                    <span>
                                        <a href="https://rekyc.moneysukh.com:9443/directpan.aspx">Account Closure</a>
                                    </span>
                                    <small>|</small>
                                    <span onClick={changeRisk}>
                                        <a href="">Risk Disclosures</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href={pdfClient} target="_blank">Advisory for Investors</a>
                                    </span>
                                    <small>|</small>
                                    <span>
                                        <a href="https://smartodr.in" target="_blank">SMART ODR</a>
                                    </span>
                                </li>

                            </ul>
                            <ul className="useful-links-block">
                                <li>
                                    <span>Important links:</span>
                                </li>
                                <li>
                                    <a href="https://www.nseindia.com/" target="_blank">
                                        NSE
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.bseindia.com/" target="_blank">
                                        BSE
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.cdslindia.com/" target="_blank">
                                        CDSL
                                    </a>
                                </li>
                                <li>
                                    <a href="https://nsdl.co.in/" target="_blank">
                                        NSDL
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.sebi.gov.in/" target="_blank">
                                        SEBI
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.mcxindia.com/" target="_blank">
                                        MCX
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.msei.in/" target="_blank">
                                        MSEI
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.ncdex.com/" target="_blank">
                                        NCDEX
                                    </a>
                                </li>
                                {/* <li>
                                    <a href="https://www.nseifsc.com/" target="_blank">
                                        NSE IFSC
                                    </a>
                                </li> */}
                                <li>
                                    <a href="https://www.indiainx.com/" target="_blank">
                                        INDIA INX
                                    </a>
                                </li>
                            </ul>
                            <ul className="prevent-block">
                                <li>
                                    <p className="footerp">
                                        <b>Attention Investors:</b> As per NSE circular dated July 6, 2022, BSE circular dated July 6, 2022, MCX circular dated July 11, 2022 investors are cautioned to abstain them from dealing in any schemes of unauthorised collective investments/portfolio management, indicative/ guaranteed/fixed returns / payments etc. Investors are further cautioned to avoid practices like:</p>
                                    <p className="footerp">
                                        a) Sharing i) trading credentials – login id & passwords including OTP’s., ii) trading strategies, iii) position details.</p>
                                    <p className="footerp">
                                        b) Trading in leveraged products /derivatives like Options without proper understanding, which could lead to losses.</p>
                                    <p className="footerp">
                                        c) Writing/ selling options or trading in option strategies based on tips, without basic knowledge & understanding of the product and its risks</p>
                                    <p className="footerp">
                                        d) Dealing in unsolicited tips through like Whatsapp, Telegram, Instagram, YouTube, Facebook, SMS, calls, etc.</p>
                                    <p >
                                        e) Trading / Trading in “Options” based on recommendations from unauthorised / unregistered investment advisors and influencers.</p>
                                    <p>
                                        Kindly, read the Advisory Guidelines For Investors as prescribed by the Exchange with reference to their circular dated 27th August, 2021 regarding investor awareness and safeguarding client's assets
                                    </p>
                                    <p>
                                        Kindly, read the advisory as prescribed by the Exchange with reference to their circular dated January 14, 2022 regarding Updation of mandatory KYC fields by March 31, 2022
                                    </p>
                                    <p>
                                        <b>Attention Investors:</b> Prevent unauthorized transactions in your demat account. Update your mobile number with your depository participant. Receive alerts on your registered mobile number for debit and other important transactions in your demat account directly from CDSL on the same day. Prevent unauthorized transactions in your trading account. Update your mobile numbers/email address with your stock brokers. Receive information of your transactions directly from the Exchange on your mobile/email at the end of the day. This is issued in the interest of investors. KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI registered intermediary (broker, DP, Mutual Fund, etc...), you need not undergo the same process again when you approach another intermediary.
                                    </p>
                                    <p>
                                        No need to issue cheques by investors while subscribing to IPO. Just write the bank account number and sign in the application form to authorise your bank to make payment in case of allotment. No worries for refund as the money remains in investor's account.
                                    </p>
                                    <p className="footerp">
                                        Stockbrokers can accept securities as margin from their clients only by way of a pledge in the depository system w.e.f. 1st September 2020.</p>
                                    <p>
                                        Update your email ID and mobile number with your stockbroker/depository participant and receive an OTP directly from the depository on your registered email ID and/or mobile number to create a pledge.
                                        Check your securities/mutual funds/bonds in the Consolidated Account Statement (CAS) issued by NSDL/CDSL every month.
                                    </p>
                                    <p>
                                        ICCL and MCXCCL provides a web-based facility available at <a href="https://bseplus.bseindia.com" target="_blank">https://bseplus.bseindia.com</a>  & <a href="https://clientreports.mcxccl.com/#/" target="_blank" >https://clientreports.mcxccl.com/#/</a>  respectively  to investors to view their disaggregated collateral placed with Member. All investors can use the same after following simple online registration process.
                                    </p>

                                </li>
                            </ul>
                        </Col>

                    </Row>

                    <section className="copyright-cmots">
                        <Row>
                            <Col sx={12} lg={6} md={6}>
                                <p className="copyright_text m-0">{copywrite}</p>
                            </Col>
                            <Col sx={12} lg={6} md={6}>
                                <div className="footerapp_panel text-right">
                                    <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN">
                                        <img src={PlayStore} alt="PlayStore" />
                                    </a>
                                    <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241">
                                        <img src={AppStore} alt="AppStore" />
                                    </a>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sx={12} lg={12} md={12} className="text-right">
                                {/* <span className="copyright_text m-0"> Designed,Developed and Content powered by <a target='_blank' href="http://www.cmots.com/">CMOTS Infotech </a> (ISO 9001:2015 certified) </span> */}
                                <span className="copyright_text m-0"> Designed,Developed and Content powered by <a target='_blank' href="http://www.cmots.com/">CMOTS Infotech </a> (ISO 9001:2015 & ISO/IEC 27001:2022 Certified) </span>
                            </Col>
                        </Row>
                    </section>
                </Container>
            </div>
        </>
    );
}

export default Footer;